import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col
} from "reactstrap";
import moment from 'moment';
import { getUserRequest } from '../../api/user';

class UserDetails extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
          user: null,
        }
    }

    async componentDidMount() {
        const params = new URLSearchParams(this.props.location.search);
        const id = params.get('id');

        if (id) {
            const user = await getUserRequest(id);
            this.setState({ 
              user
            })
        } else {
            this.goTo('/users')
        }
    }
  
    goTo = path => this.props.history.push(path);

    render() {

        const {
            user={}
        } = this.state;
        
        return (
            <>
            <div className="content">
              <Row>
                <Col md="12">
                  <Card>
                    <CardHeader className="mb-5">
                      <CardTitle tag="h3">
                        User Details
                      </CardTitle>
                      <Button 
                        className="float-right"
                        color="default"
                        onClick={() => this.goTo('/users')}
                      >
                        Back
                      </Button>
                    </CardHeader>
                    <CardBody>
                      {!user 
                      ? <div>Loading...</div>
                      : <>
                      <div className="typography-line">
                        <h4>
                          <span>ID</span>
                          {user._id}
                        </h4>
                      </div>
                      <div className="typography-line">
                        <h4>
                          <span>Email</span>
                          {user.email}
                        </h4>
                      </div>
                      <div className="typography-line">
                        <h4>
                          <span>First Name</span>
                          {user.first_name}
                        </h4>
                      </div>
                      <div className="typography-line">
                        <h4>
                          <span>Last Name</span>
                          {user.last_name}
                        </h4>
                      </div>
                      <div className="typography-line">
                        <h4>
                          <span>Role</span>
                          {user.role}
                        </h4>
                      </div>
                      <div className="typography-line">
                        <h4>
                          <span>Phone</span>
                          {user.phone || "N/A"}
                        </h4>
                      </div>
                      <div className="typography-line">
                        <h4>
                          <span>Created At</span>
                          {user.created_at ? moment(user.created_at).format("YYYY-MM-DD HH:mm:ss") : "N/A"}
                        </h4>
                      </div>
                      <div className="typography-line">
                        <h4>
                          <span>Update At</span>
                          {user.updated_at ? moment(user.updated_at).format("YYYY-MM-DD HH:mm:ss") : "N/A"}
                        </h4>
                      </div>
                      </>
                      }
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </div>
          </>
        );
    }
}

export default UserDetails;
